import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './GoogleLocation.module.scss';

const Marker = ({ text, onClick, useTextbox }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <div
        className={classes.locationPin}
        title={text}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <FontAwesomeIcon icon={['fas', 'location-dot']} />
      </div>
      {useTextbox && isHovered && <span className={classes.textBox}>{text}</span>}
    </>
  );
};

Marker.defaultProps = {
  onClick: null,
  text: ''
};

Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired
};

export default Marker;
